import React, { PropsWithChildren } from "react";
import { observer } from "mobx-react";
import { injectFromApp } from "../../inject";

interface IModalDialogHeaderComponentProps {
    title: string;
    className?: string;
    onClose?: () => void;
}

@injectFromApp<IModalDialogHeaderComponentProps>((stores) => ({}))

@observer
export class ModalDialogHeaderComponent extends React.Component<PropsWithChildren<IModalDialogHeaderComponentProps>> {
    onCloseClicked = (event) => {
        if (this.props.onClose == null) return;
        this.props.onClose();
    };

    render() {
        const { props } = this;
        const { title, className } = props;

        return (
            <div className={"modal-dialog-header " + (className ?? "")}>
                <h1 className={"title"}>{title}</h1>
                <div className={"close"} onClick={this.onCloseClicked}>
                    &nbsp;
                </div>
            </div>
        );
    }
}
